import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
  const location = useLocation();
  const { user, checkingAuth } = useAuth();
  const loginState = useMemo(() => ({ from: location }), [location]);

  if (checkingAuth || user === null) {
    return <div className="mx-auto max-w-5xl px-4 py-10 font-black" data-testid="auth-checking-state">Verificando acesso...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={loginState} />;
  }

  return <Outlet />;
}